<template>
    <header
        id="page-header"
        ref="headerRef"
        class="sticky top-0 z-[99998] bg-white shadow-lg xl:top-[51px]"
    >
        <div
            id="nav-menu"
            class="h-[65px] flex-col items-center xl:mx-auto xl:h-[80px] xl:flex-row xl:justify-between xl:gap-x-12"
        >
            <MobileMainMenu :data="data || null" />
            <MainMenu :data="data || null" />
        </div>
    </header>
</template>

<script setup lang="ts">
import {
    useLocalStructuredData,
    useOrganizationStructuredData,
} from '~/composables/useStructuredData';
import MainMenu from '~/layouts/includes/menu/MainMenu.vue';
import MobileMainMenu from '~/layouts/includes/menu/MobileMainMenu.vue';

const { data: data } = await useFetch(`/nuxt-api/global/header`);

const organizationStructuredData = useOrganizationStructuredData();

if (import.meta.server) {
    useHead(() => ({
        script: organizationStructuredData,
    }));
}

const localStructuredData = useLocalStructuredData();

if (import.meta.server) {
    useHead(() => ({
        script: localStructuredData,
    }));
}
</script>
